import { Link, useNavigate } from "react-router";
import { Button } from "flowbite-react";
import { Home, ShieldX } from "lucide-react";
import { H1 } from "@/shared/ui/typographies/h1";
import { P } from "@/shared/ui/typographies/paragraph";

export const AccessDeniedPage = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center gap-6 min-h-screen -mt-16 text-center page-animation">
      <ShieldX size={80} className="text-error" />

      <H1>Accès refusé</H1>

      <P className="text-gray-600 dark:text-gray-300">
        Désolé, vous n'avez pas accès à cette fonctionnalité.
      </P>

      <div className="flex items-center text-sm gap-0.5 text-gray-600 dark:text-gray-300">
        Si vous pensez que c'est une erreur,
        {" "}
        <Link to="/aide" className="text-primary hover:text-primary dark:text-primary dark:hover:text-primary underline">ouvrez un ticket</Link>
        .
      </div>

      <Button
        onClick={() => navigate("/")}
        color="primary"
      >
        <Home size={16} className="mr-2" />
        Retour à l'accueil
      </Button>
    </div>
  );
};
